import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UserStatusCssProviderService } from '../providers/user-status-css.provider.service';
import { UserStatus } from '../enums/user-status';

@Pipe({
  name: 'userStatusCss',
  standalone: true,
})
export class UserStatusCssPipe implements PipeTransform {
  private readonly provider = inject(UserStatusCssProviderService);

  public transform(status: UserStatus): Observable<string> {
    return this.provider.css(status);
  }
}
